<form [formGroup]="metadataFormGroup">
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Date de début</label>
      <input type="date" class="form-control" formControlName="startDate" />
    </div>
    <div class="col">
      <label i18n>Durée du contrat</label>
      <input
        type="text"
        class="form-control"
        formControlName="contractDuration"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Mode de paiement</label>
      <select class="form-control" formControlName="paymentFrequency">
        <option *ngFor="let value of paymentFrequencyValues" [value]="value">
          {{ getPaymentFrequencyLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Supplément pour paiement fractionné en %</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="splitPaymentFee"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>

  <div
    class="row my-3"
    *ngIf="
      metadataFormGroup.value.hasclaimsLastFiveYears === 'true' ||
      metadataFormGroup.value.hasclaimsLastFiveYears === true
    "
  >
    <div class="col">
      <label i18n>Détails des sinistres</label>
      <textarea
        class="form-control"
        rows="3"
        formControlName="claims"
      ></textarea>
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>Catégorie 1</label>
      <input type="text" class="form-control" formControlName="categoryOne" />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Responsabilité civile
  </div>
  <div formGroupName="civilResponsability">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Responsabilité civile</label>
        <div class="form-check">
          <input
            type="radio"
            name="civilResponsability"
            id="civilResponsabilityFalse"
            [value]="false"
            formControlName="civilResponsability"
          />
          <label class="form-check-label" for="civilResponsabilityFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="civilResponsability"
            id="civilResponsabilityTrue"
            [value]="true"
            formControlName="civilResponsability"
          />
          <label class="form-check-label" for="civilResponsabilityTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Protection du bonus</label>
        <div class="form-check">
          <input
            type="radio"
            id="civilBonusProtectionFalse"
            [value]="false"
            formControlName="bonusProtection"
          />
          <label class="form-check-label" for="civilBonusProtectionFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="civilBonusProtectionTrue"
            [value]="true"
            formControlName="bonusProtection"
          />
          <label class="form-check-label" for="civilBonusProtectionTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Renonciation à la faute grave</label>
        <div class="form-check">
          <input
            type="radio"
            id="civilSeriousMisconductWaiverFalse"
            [value]="false"
            formControlName="seriousMisconductWaiver"
          />
          <label
            class="form-check-label"
            for="civilSeriousMisconductWaiverFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="civilSeriousMisconductWaiverTrue"
            [value]="true"
            formControlName="seriousMisconductWaiver"
          />
          <label class="form-check-label" for="civilSeriousMisconductWaiverTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>Casco</div>
  <div formGroupName="casco">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Casco collision</label>
        <div class="form-check">
          <input
            type="radio"
            name="cascoCollision"
            id="cascoCollisionFalse"
            [value]="false"
            formControlName="cascoCollision"
          />
          <label class="form-check-label" for="cascoCollisionFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="cascoCollision"
            id="cascoCollisionTrue"
            [value]="true"
            formControlName="cascoCollision"
          />
          <label class="form-check-label" for="cascoCollisionTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Protection du bonus</label>
        <div class="form-check">
          <input
            type="radio"
            id="cascoBonusProtectionFalse"
            [value]="false"
            formControlName="bonusProtection"
          />
          <label class="form-check-label" for="cascoBonusProtectionFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="cascoBonusProtectionTrue"
            [value]="true"
            formControlName="bonusProtection"
          />
          <label class="form-check-label" for="cascoBonusProtectionTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Renonciation à la faute grave</label>
        <div class="form-check">
          <input
            type="radio"
            id="cascoSeriousMisconductWaiverFalse"
            [value]="false"
            formControlName="seriousMisconductWaiver"
          />
          <label
            class="form-check-label"
            for="cascoSeriousMisconductWaiverFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="cascoSeriousMisconductWaiverTrue"
            [value]="true"
            formControlName="seriousMisconductWaiver"
          />
          <label class="form-check-label" for="cascoSeriousMisconductWaiverTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Casco partielle</label>
        <div class="form-check">
          <input
            type="radio"
            name="partialCasco"
            id="partialCascoFalse"
            [value]="false"
            formControlName="partialCasco"
          />
          <label class="form-check-label" for="partialCascoFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="partialCasco"
            id="partialCascoTrue"
            [value]="true"
            formControlName="partialCasco"
          />
          <label class="form-check-label" for="partialCascoTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Franchise en vol</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="theftDeductible"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couverture des phares Xénon/LED</label>
        <div class="form-check">
          <input
            type="radio"
            name="xenonLedHeadlightsCoverage"
            id="xenonLedHeadlightsCoverageFalse"
            [value]="false"
            formControlName="xenonLedHeadlightsCoverage"
          />
          <label class="form-check-label" for="xenonLedHeadlightsCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="xenonLedHeadlightsCoverage"
            id="xenonLedHeadlightsCoverageTrue"
            [value]="true"
            formControlName="xenonLedHeadlightsCoverage"
          />
          <label class="form-check-label" for="xenonLedHeadlightsCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Effets de voyage</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="travelEffects"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Assistance en CH et/ou UE</label>
        <div class="form-check">
          <input
            type="radio"
            name="swissEuAssistance"
            id="swissEuAssistanceFalse"
            [value]="false"
            formControlName="swissEuAssistance"
          />
          <label class="form-check-label" for="swissEuAssistanceFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="swissEuAssistance"
            id="swissEuAssistanceTrue"
            [value]="true"
            formControlName="swissEuAssistance"
          />
          <label class="form-check-label" for="swissEuAssistanceTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Véhicule de remplacement</label>
        <div class="form-check">
          <input
            type="radio"
            name="replacementVehicle"
            id="replacementVehicleFalse"
            [value]="false"
            formControlName="replacementVehicle"
          />
          <label class="form-check-label" for="replacementVehicleFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="replacementVehicle"
            id="replacementVehicleTrue"
            [value]="true"
            formControlName="replacementVehicle"
          />
          <label class="form-check-label" for="replacementVehicleTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Cross Liability</label>
        <div class="form-check">
          <input
            type="radio"
            name="crossLiability"
            id="crossLiabilityFalse"
            [value]="false"
            formControlName="crossLiability"
          />
          <label class="form-check-label" for="crossLiabilityFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="crossLiability"
            id="crossLiabilityTrue"
            [value]="true"
            formControlName="crossLiability"
          />
          <label class="form-check-label" for="crossLiabilityTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Franchise générale en casco partiel</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="partialCascoDeductible"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Casco parc</label>
        <div class="form-check">
          <input
            type="radio"
            name="cascoParc"
            id="cascoParcFalse"
            [value]="false"
            formControlName="cascoParc"
          />
          <label class="form-check-label" for="cascoParcFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="cascoParc"
            id="cascoParcTrue"
            [value]="true"
            formControlName="cascoParc"
          />
          <label class="form-check-label" for="cascoParcTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Franchise casco parc</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="cascoParcDeductible"
        />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Libre choix de la carrosserie</label>
        <div class="form-check">
          <input
            type="radio"
            name="bodyworkFreeChoice"
            id="bodyworkFreeChoiceFalse"
            [value]="false"
            formControlName="bodyworkFreeChoice"
          />
          <label class="form-check-label" for="bodyworkFreeChoiceFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="bodyworkFreeChoice"
            id="bodyworkFreeChoiceTrue"
            [value]="true"
            formControlName="bodyworkFreeChoice"
          />
          <label class="form-check-label" for="bodyworkFreeChoiceTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Accidents des occupants
  </div>
  <div formGroupName="occupantsAccidents">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Accidents des occupants</label>
        <div class="form-check">
          <input
            type="radio"
            name="occupantsAccidents"
            id="occupantsAccidentsFalse"
            [value]="false"
            formControlName="occupantsAccidents"
          />
          <label class="form-check-label" for="occupantsAccidentsFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="occupantsAccidents"
            id="occupantsAccidentsTrue"
            [value]="true"
            formControlName="occupantsAccidents"
          />
          <label class="form-check-label" for="occupantsAccidentsTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Capital décès</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deathBenefit"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Capital invalidité</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="disabilityCapital"
        />
      </div>
      <div class="col">
        <label i18n>Indemnité journalière</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="dailyAllowance"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Indemnité d'hospitalisation</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="hospitalisationAllowance"
        />
      </div>
      <div class="col">
        <label i18n>Frais de traitement illimités</label>
        <div class="form-check">
          <input
            type="radio"
            name="unlimitedTreatmentFee"
            id="unlimitedTreatmentFeeFalse"
            [value]="false"
            formControlName="unlimitedTreatmentFee"
          />
          <label class="form-check-label" for="unlimitedTreatmentFeeFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="unlimitedTreatmentFee"
            id="unlimitedTreatmentFeeTrue"
            [value]="true"
            formControlName="unlimitedTreatmentFee"
          />
          <label class="form-check-label" for="unlimitedTreatmentFeeTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>
  </div>
</form>
